module.exports = __webpack_public_path__ + "img/rich-text.e05415fa.svg";